import React from 'react';
import { FadeIn } from './ui/FadeIn';
import { XCircleIcon } from 'lucide-react';
export function FailedAttemptsSection() {
  const attempts = ['Intentaste dejarlo llorar sin una estructura, lo que solo generó más estrés (cortisol) en el bebé y culpa en ti.', 'Le das leche cada vez que despierta para que se calle rápido, entrenando su estómago para pedir comida a las 2 AM por el resto del año.', 'Los fines de semana cambias el horario para "compensar", lo que destruye el reloj biológico del bebé para el lunes.', 'No estás usando el sonido blanco o la oscuridad total de la manera técnica correcta para cancelar el ruido del tráfico o los vecinos.'];
  return <section className="py-24 px-4 bg-navy-800" data-id="element-55">
      <div className="max-w-4xl mx-auto" data-id="element-56">
        <FadeIn data-id="element-57">
          <h2 className="text-3xl md:text-4xl font-bold text-cream mb-12 text-center" data-id="element-58">
            Por Qué Lo Que Intentaste{' '}
            <span className="text-red-400/90 italic" data-id="element-59">No Funcionó</span>
          </h2>
        </FadeIn>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-60">
          {attempts.map((attempt, index) => <FadeIn key={index} delay={0.1 * (index + 1)} data-id="element-61">
              <div className="bg-navy-700 p-6 md:p-8 rounded-2xl h-full border border-navy-600 hover:border-red-400/30 transition-colors" data-id="element-62">
                <div className="flex items-start gap-4" data-id="element-63">
                  <XCircleIcon className="w-6 h-6 text-red-400/80 shrink-0 mt-1" data-id="element-64" />
                  <p className="text-muted leading-relaxed" data-id="element-65">{attempt}</p>
                </div>
              </div>
            </FadeIn>)}
        </div>
      </div>
    </section>;
}